'use strict';

DoohApps
       .factory('Invoice', ['restApi', function (restApi) {
        var controllerName = 'Invoice/';

        return {
            getCompanyInvoices: function (successCallback, filter) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompanyInvoices', filter);
            },
            getCompanyPOOverview: function (successCallback, filter) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompanyPOOverview', filter);
            },
            getCompaniesCredits: function (successCallback, filter) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompaniesCredits', filter);
            },
            addCredits: function (successCallback, transaction) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostAccountTransaction', transaction);
            },
        }
    }]);
